export const MONITOR_PATH = '/monitor' as const;
export const COMPLETENESS_CHECK_PATH = '/completeness-check' as const;
export const REPORTS_PATH = '/reports' as const;
export const MONITOR__DETAILS_PATH = '/monitor-details' as const;
export const SETTINGS_PATH = '/settings' as const;
export const FORBIDDEN_PATH = '/forbidden' as const;
